import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

function ApiDocs() {
    return (
        <div style={{ position: 'relative', marginBottom: '50px' }}>
            {window.location.hostname.includes('cardgarant') ?  <SwaggerUI url="./openapicardgarant.yaml" /> : <SwaggerUI url="./openapihumanaised.yaml" />}
            <style>
                {`
                    /* Скрыть блок схем внизу Swagger UI */
                    .models {
                        display: none !important;
                    }
                `}
            </style>
        </div>
    );
}

export default ApiDocs;
